import {
  noNotice,
  saveBindForm,
  merge,
  mergeForm
} from '@/services/merge'
import rules from '../account/rules'
export default {
  namespaced: true,
  state: {
    decorators: {
      username: ['username', { rules: rules.username }],
      password: ['password', { rules: rules.password }]
    }
  },
  mutations: {
  },
  getters: {
  },
  actions: {
    // 不再提醒
    async ajaxNoNotice ({ commit }) {
      const chain = await noNotice()
        .onSuccess(raw => {
        })
        .config({
          tip: false
        })
      return chain
    },
    // 合并保存
    async ajaxSave ({ commit, dispatch }, userid) {
      const chain = await saveBindForm()
        .onSuccess(raw => {
          // const chain = dispatch('getPeronListsDatas', userid)
          // chain.fetch()
        })
        .config({
          tip: false
        })
      return chain
    },
    async mergeQw ({ commit, dispatch }, userid) {
      const chain = await merge()
        .onSuccess(raw => {
          // const chain = dispatch('getPeronListsDatas', userid)
          // chain.fetch()
        })
        .config({
          tip: false,
          warn: false
        })
      return chain
    },
    async mergeForm ({ commit, dispatch }, userid) {
      const chain = await mergeForm()
        .onSuccess(raw => {
          // const chain = dispatch('getPeronListsDatas', userid)
          // chain.fetch()
        })
        .config({
          tip: false
        })
      return chain
    }
  }
}
